import OpenAI from "openai";

const openai = new OpenAI({
  apiKey: process.env.REACT_APP_OPENAI_API_KEY,
  dangerouslyAllowBrowser: true 
})

const createImagePromptGPT = async (prompt, gptVersion) => {
  try {

      const chatCompletion = await openai.chat.completions.create({
        model: gptVersion,
        temperature: 1,
        messages:
          [
            {
              "role": "user",
              "content": prompt
            },
          ],
        // tools: [
        //   {
        //     "type": "function",
        //     "function": {
        //       "name": "translate_sentence",
        //       "description": "translate english sentence into korean",
        //       "parameters": {
        //         "type": "object",
        //         "properties": {
        //           "props": {
        //             "type": "array",
        //             "items": {
        //               "type": "object",
        //               "properties": {
        //                 "english": { "type": "string", "description": "english sentence" },
        //                 "korean": { "type": "string", "description": "english to korean" },
        //               }
        //             }
        //           }
        //         },
        //         "required": ["props"]
        //       }
        //     },
        //   }
        // ]
      });
        const newSentence = chatCompletion.choices[0].message.content
        return newSentence
    
  } catch (error) {
    if (error instanceof OpenAI.APIError) {
      console.error(error.status);  // e.g. 401
      console.error(error.message); // e.g. The authentication token you passed was invalid...
      console.error(error.code);  // e.g. 'invalid_api_key'
      console.error(error.type);  // e.g. 'invalid_request_error'

      return false
    } else {
      // Non-API error
      console.log(error);
    }
    return false
  }
}

export default createImagePromptGPT